import styles from "./LsBalance.module.scss";
import { inputFocusMessage } from "../../../../Utils/iframeMessenger";
import Text from "../../../Typography/Text/Text";
import arrow from "../../../../Static/images/accordionUp.svg";
import { useState, useRef } from "react";

const LsBalance = ({ lsBalanceInfo, lsInputChange }) => {
  const [accordionActive, setAccordionActive] = useState(false);

  const input = useRef();

  function calculateBalance() {
    let balance = lsBalanceInfo.services.reduce((accumulator, item) => {
      if (item.amount > 0) {
        return accumulator + item.amount + item.penaltie;
      } else {
        return accumulator;
      }
    }, 0);
    if (balance > 0) {
      return balance.toFixed(2);
    } else {
      return 0;
    }
  }

  function onChangeInputValue() {
    let filteredValue;
    filteredValue = input.current.value
      .replace(/^[^\d]/g, "")
      .replace(/[^\d.]/g, "")
      .replace(/^([^.]*\.)|\./g, "$1");
    if (filteredValue.indexOf(".") !== -1) {
      filteredValue = filteredValue.substring(
        0,
        filteredValue.indexOf(".") + 3
      );
    }
    input.current.value = filteredValue;
    lsInputChange();
  }

  return (
    <div
      className={
        accordionActive
          ? `${styles.lsBalance} ${styles.accordionActive}`
          : `${styles.lsBalance}`
      }
    >
      <div className={styles.header}>
        <div className={styles.lsInfo}>
          <div className={styles.ls}>
            <Text size="headerText" fw={500}>
              ЛС № {lsBalanceInfo.number}
            </Text>
          </div>
          <div
            className={styles.service}
            onClick={() => setAccordionActive(!accordionActive)}
          >
            <div className={styles.serviceName}>
              {lsBalanceInfo.service_name}
            </div>
            <div className={styles.arrow}>
              <img src={arrow} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.input}>
          <input
            onChange={() => onChangeInputValue()}
            onFocus={() => inputFocusMessage("openNumKeyboard")}
            onBlur={() => inputFocusMessage("closeKeyboard")}
            defaultValue={calculateBalance()}
            name="lsInput"
            ref={input}
            maxLength={10}
          />
        </div>
      </div>
      <div className={styles.content}>
        {lsBalanceInfo.services.map((item, idx) => {
          return (
            <div className={styles.item} key={idx}>
              <div className={styles.serviceTitle}>{item.service_title}:</div>
              <div className={styles.balance}>
                <Text size="headerText">
                  {item.amount} руб
                  {item.penaltie > 0 ? " +" : ""}
                </Text>
                {item.penaltie > 0 && (
                  <div className={styles.stafen}>
                    <Text size="headerText">{item.penaltie} руб (пени)</Text>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LsBalance;
